import React from "react";
import { ArrowUpRight } from "lucide-react";

const PARTNERS = [
  { name: "Google", src: "/brand/partners/google.png", h: "h-7 md:h-8" },
  { name: "Australian Broadcasting Corporation", src: "/brand/partners/abc.svg", h: "h-10 md:h-12" },
  { name: "Australian Government — Department of Health and Aged Care", src: "/brand/partners/doh.png", h: "h-12 md:h-14" },
  { name: "Doherty Institute", src: "/brand/partners/doherty.png", h: "h-10 md:h-12" },
  { name: "Burnet Institute", src: "/brand/partners/burnet.png", h: "h-12 md:h-14" },
  { name: "Johns Hopkins University", src: "/brand/partners/jhu.png", h: "h-24 md:h-20" },
  { name: "The Lancet", src: "/brand/partners/lancet.png", h: "h-10 md:h-12" },
  { name: "Medical Journal of Australia", src: "/brand/partners/mja.png", h: "h-9 md:h-10" },
  { name: "Grattan Institute", src: "/brand/partners/grattan.png", h: "h-9 md:h-10" },
  { name: "New England Complex Systems Institute", src: "/brand/partners/necsi.png", h: "h-8 md:h-9" },
  { name: "Nine", src: "/brand/partners/nine.png", h: "h-7 md:h-8" },
  { name: "Our World in Data", src: "/brand/partners/owid.png", h: "h-10 md:h-12" },
  { name: "The Sydney Morning Herald & The Age", src: "/brand/partners/smh-age.png", h: "h-12 md:h-14" },
];

export default function CaseStudy() {
  return (
    <section id="case-study" data-testid="case-study-section" className="py-24 md:py-32 bg-[#0A0A0A] text-white relative overflow-hidden">
      <div className="absolute inset-0 dot-bg opacity-20 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="overline mb-5 text-[#FDE047]">Case study — 2020/2024</p>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1] mb-8">
              The COVID-19<br />dashboards that<br />served a nation.
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-lg">
              Our founders built and operated the COVID-19 data services Australians relied on during the pandemic. Our data was trusted by media, health authorities, researchers, and the federal government.
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="border border-white/20 px-3 py-1.5 text-sm font-mono">Live platform</span>
              <span className="border border-white/20 px-3 py-1.5 text-sm font-mono">Data pipeline</span>
              <span className="border border-white/20 px-3 py-1.5 text-sm font-mono">Public interest</span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-0 border border-white/15">
              <Big number="10M+" label="Australians reached" testid="case-stat-users" />
              <Big number="500M+" label="Dashboard views" testid="case-stat-views" accent />
            </div>

            <div className="mt-8 border-t border-white/15 pt-6">
              <p className="overline mb-5 text-white/60">Trusted by teams at</p>
              <div className="flex flex-wrap items-center gap-x-10 gap-y-6">
                {PARTNERS.map((p, i) => (
                  <img
                    key={p.name}
                    src={p.src}
                    alt={p.name}
                    data-testid={`partner-logo-${i}`}
                    draggable="false"
                    loading="lazy"
                    className={`${p.h} w-auto object-contain select-none of-logo-invert opacity-60 hover:opacity-100 transition-opacity duration-300`}
                  />
                ))}
              </div>
            </div>

            <a
              href="/#contact"
              data-testid="case-study-cta"
              onClick={() => window.gtag?.('event', 'cta_click', { location: 'case_study' })}
              className="mt-10 inline-flex items-center gap-2 bg-[#FDE047] text-[#0A0A0A] px-6 py-3.5 font-medium hover:bg-white transition-colors"
            >
              Build your own
              <ArrowUpRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function Big({ number, label, accent, testid }) {
  return (
    <div data-testid={testid} className={`p-8 md:p-10 border-white/15 border-b border-r ${accent ? "bg-[#0052FF]" : ""}`}>
      <div className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-none mb-3">
        {number}
      </div>
      <div className="text-xs md:text-sm uppercase tracking-wider text-white/70 font-mono">{label}</div>
    </div>
  );
}